import React from 'react'
import SubHeader from '../general/SubHeader'
import Odisha from '../assets/odisha.avif';

const partnersData = [
  {
    state: 'Odisha',
    description:
      'Building strong regional collaborations and empowering digital growth across Odisha through trusted partnerships.',
    image:
     Odisha,
  },

]

const Partners = () => {
  return (
    <>
      <SubHeader message='Partners' />


 <section className='my-5'>
                <div className='container'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Our Partners</p>
                    <p className='sec-heading my-0'>Expanding Across India</p>

    <p className="partners-text mx-auto">
              We are proud to collaborate with reliable partners who help us
              deliver excellence and grow our presence across multiple regions.
            </p>

            {partnersData.map((partner, index) => (
              <div className="col-12 my-2" key={index}>
                <div className="row bg-light rounded-4">
                  
                  <div className='col-md-5 p-0'>
                    <img
                      src={partner.image}
                      alt={partner.state}
className="img-fluid rounded-start-4"                     /></div>


                  <div className="col-md-7 align-content-center">
                    <h3>{partner.state}</h3>

                    <p>{partner.description}</p>


                    <p className='fst-italic fw-semibold'>● Digit Hack Software Solutions</p>
<p>At DigIT-Hack, we empower businesses with innovative technology solutions designed to drive growth and efficiency. Our team delivers reliable web applications, custom software, and digital solutions tailored to meet the unique needs of modern businesses.</p>

                  </div>
                </div>
              </div>
            ))}

</div>
      </section>


 
    </>
  )
}

export default Partners